import { forwardRef } from 'react';
import { Card } from '@mantine/core';

// For facet tooltips
// 10px from the top of the plot
// Max width = plotWidth

const PlotTooltip = (props,ref) => {
    
    const {tooltipOffset,tooltipWidth,children,isFacetPlot} = props;

    // Console log the width of the tooltip using ref
    const tooltipActualWidth = ref.current ? ref.current.offsetWidth : 0;
    
    const tooltipStyles = {
        position: 'absolute',
        top: isFacetPlot ? 10 : 0,
        // Center facet plots using refs
        left: isFacetPlot ? `calc(50% - ${tooltipActualWidth / 2}px)` : 0,
        maxWidth: isFacetPlot ? `calc(100% - 5px)` : `initial`,
        width: isFacetPlot ? 'auto' : `${tooltipWidth}px`,
        textAlign: 'center',
        pointerEvents:'none',
        zIndex: 9999,
        transform: isFacetPlot ? `initial` : `translate(${tooltipOffset.x}px, ${tooltipOffset.y}px)`,
    };

    return (
        <Card
            ref={ref}
            shadow="sm"
            px={isFacetPlot ? 'xs' : "md"}
            py="xs"
            withBorder
            radius = 'md'
            style = {tooltipStyles}
        >
        {children}
    </Card>
    )
}

export default forwardRef(PlotTooltip);